import { isLiveTv, ITEM_TYPES, itemHasStarted } from 'Utils';

export const defaultRecStorage = 'iptv,go';

export const RECORDING_STATUS = Object.freeze({
    DONE: 'done',
    PLANNED: 'planned',
    ARCHIVED: 'archived',
    NOT_RECORDED: 'notRecorded'
});

export const getRecordingForItem = (item) =>
    item?.recordings && item?.recordings?.length > 0 ? item.recordings[0] : {};

export const hasRecordingData = (item) => {
    const { data } = getRecordingForItem(item);
    return Boolean(data);
};

/**
 * @returns {RECORDING_STATUS}
 */
export const getRecordingStatus = (item) => {
    const { data } = getRecordingForItem(item);
    return data ? data.status : RECORDING_STATUS.NOT_RECORDED;
};

export const getRecordIconByType = (data) =>
    data.type === 'SIMPLE' ? 'player_record_on' : 'record_series';

export const itemCanBePlayed = (item) => {
    let canBePlayed = true;
    const itemHasStartedFlag = itemHasStarted(item);

    if (isLiveTv(item)) {
        canBePlayed = itemHasStartedFlag;
    }

    // Only GO recordings can be played
    const { data: recData } = getRecordingForItem(item);
    if (recData && item.modelType === ITEM_TYPES.RECORDING && itemHasStartedFlag) {
        canBePlayed = !(
            recData.platform === 'iptv' &&
            (recData.status === RECORDING_STATUS.DONE ||
                recData.status === RECORDING_STATUS.ARCHIVED)
        );
    }

    if (!itemHasStartedFlag && item.modelType === ITEM_TYPES.RECORDING) {
        canBePlayed = false;
    }

    if (item.modelType === ITEM_TYPES.RECORDING_SERIES) {
        canBePlayed = false;
    }

    if (item?.hasBlackout && item?.hasBlackout()) {
        canBePlayed = false;
    }

    return Boolean(canBePlayed);
};

/**
 * @param {{ iptv: boolean | string, go: boolean | string }} platforms
 * @returns {string}
 */
export const getPlatformsStorageString = (platforms) => {
    const platformsStorage = [];

    if (!platforms.go && !platforms.iptv) {
        return defaultRecStorage;
    }

    if (platforms.iptv) {
        platformsStorage.push('iptv');
    }

    if (platforms.go) {
        platformsStorage.push('go');
    }

    return platformsStorage.join(',');
};

export const getRecordingIdsString = (ids) => {
    const recordingIds = [];

    if (ids.go) {
        recordingIds.push(ids.go);
    }

    if (ids.iptv) {
        recordingIds.push(ids.iptv);
    }

    return recordingIds.join(',');
};

export const getRecordingIdsStringByStorage = (availableIds, selectedIds) => {
    const recordingIds = [];

    // If storage is false for both platforms, return default
    if (!selectedIds.go && !selectedIds.iptv) {
        return `${availableIds.go},${availableIds.iptv}`;
    }

    if (availableIds.go && selectedIds.go) {
        recordingIds.push(availableIds.go);
    }

    if (availableIds.iptv && selectedIds.iptv) {
        recordingIds.push(availableIds.iptv);
    }

    return recordingIds.join(',');
};

// Because mCore doesn't standardise langauge codes
const languageDict = {
    cze: 'cs',
    cz: 'cs',
    ces: 'cs'
};

//  Another mCore bullshit hack
export const getStandardLanguageCode = (language) =>
    languageDict[language] ? languageDict[language] : language;

export const getTranslatedPackageName = (item, language) => {
    // Yet Another mcore bullshit hack
    const packageTranslations =
        item.data?.pckg?.packageTransDtoList?.find(
            (i) => i.locale === getStandardLanguageCode(language)
        ) || {};
    return packageTranslations.name || '';
};

export const getFirstEpisode = (episodes = []) =>
    episodes.find((episode) => episode.data.episodeNumber === 1);
